import { jsx as _jsx } from "react/jsx-runtime";
export const buildElementsTree = (componentsWithProps, initialElement) => componentsWithProps
    .reverse()
    .reduce((accumulatedElements, [_, [Component, props]]) => {
    return _jsx(Component, { ...props, children: accumulatedElements });
}, initialElement);
// Implementation:
export function wrapper(component, props) {
    return [
        '$',
        [component, props ?? {}],
    ];
}
